<template>
  <q-card flat>
    <q-card-section class="no-padding ">
      <q-banner class="bg-indigo text-white" inline-actions>
        صدور حواله {{ orderNum }}
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-chip v-if="orderInfo.Cs_Name" clickable :label="orderInfo.Cs_Name" square icon="person"
              @click="showCustomerInfo"/>
      <q-space/>
      <q-chip square label="تعداد اقلام حواله" color="indigo" text-color="white">
        <q-badge class="q-ml-sm"
                 :label="lodash.sumBy(orderItems,item=>parseInt(item.HavaG_Count)
                 + parseInt(item.Store1)  + parseInt(item.Store2)
                 + parseInt(item.Store3)
                 + parseInt(item.Store4))"
                 color="red"
                 text-color="white"/>
      </q-chip>
    </q-card-section>
    <q-card-section>
      <q-table
          :data="orderItems"
          row-key="Table_IDD"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :pagination.sync="pagination">
        <template v-slot:header>
          <tr class="text-center text-bold">
            <td>
              عنوان کالا
            </td>
            <td>
              مانده سفارش
            </td>
            <td>
              تعداد حواله شده
            </td>
            <td>
              مرکزی
            </td>
            <td>
              فروشگاه
            </td>
            <td>
              پل پنجم
            </td>
            <td>
              کارخانه صاف
            </td>
            <td>
              دیجیکالا
            </td>
          </tr>
        </template>
        <template v-slot:body="props">
          <tr :props="props" :class="props.row.SaleG_Count===0?'bg-blue-grey-2':''" v-if="!$q.screen.lt.md">
            <td class="text-subtitle2">
              <q-chip square :label="props.row.Goods_Code" clickable @click="showProductDetails(props.row)" color="red"
                      text-color="white"/>
              <q-space/>
              <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="md" color="red"
                     v-if="props.row.G_Code!==50101">
                <q-tooltip>
                  {{ props.row.General_Name }}
                </q-tooltip>
              </q-btn>
              {{ props.row.Goods_Name }}
            </td>
            <td class="text-center text-subtitle1 text-blue-8" style="width: 100px">
              {{ props.row.SaleG_Count }}
            </td>
            <td class="text-center text-subtitle1 text-bold text-teal" style="width: 100px">
              {{ props.row.HavaG_Count }}
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  v-if="stores.filter(item=> item === 1).length > 0"
                  @input="event => inputControl1(event, props.row.GStor1, props.row)"
                  @change="controlState(props.row)"
                  :disable="(props.row.G_Code!==50101 || (props.row.GStor1<0 || props.row.GStor1===0 || props.row.SaleG_Count===0)) || isShopOrder"
                  min="0"
                  v-model="props.row.Store1"
                  :label="`${props.row.GStor1}`"
                  label-color="deep-orange"
                  type="number"
                  error-message="مقدار نامعتیر می باشد"
                  filled/>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  v-if="stores.filter(item=> item === 2).length > 0"
                  @input="event => inputControl2(event, props.row.GStor2, props.row)"
                  @change="controlState(props.row)"
                  :disable="(props.row.G_Code!==50101 || props.row.GStor2<0 ||props.row.GStor2===0 || props.row.SaleG_Count===0
                  || (![1139,113218, 115187, 6616].includes(orderInfo.Cs_ID))
                  && !$store.state.roles.some(v=>['admin','can_issue_product_from_shop'].includes(v)))"
                  min="0"
                  v-model="props.row.Store2"
                  :label="`${props.row.GStor2}`"
                  label-color="deep-orange"
                  type="number"
                  filled/>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  v-if="stores.filter(item=> item === 3).length > 0"
                  @input="event => inputControl3(event, props.row.GStor3, props.row)"
                  @change="controlState(props.row)"
                  :disable="(props.row.G_Code!==50101 || props.row.GStor3<0
                  || props.row.GStor3===0 || props.row.SaleG_Count===0 || isShopOrder)"
                  min="0"
                  v-model="props.row.Store3"
                  :label="`${props.row.GStor3}`"
                  label-color="deep-orange"
                  stack-label
                  type="number"
                  filled>
              </q-input>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  v-if="stores.filter(item=> item === 4).length > 0"
                  @input="event => inputControl4(event, props.row.GStor4, props.row)"
                  @change="controlState(props.row)"
                  min="0"
                  :disable="(props.row.G_Code!==50101 || props.row.GStor4<0
                  || props.row.GStor4===0  || props.row.SaleG_Count===0 || isShopOrder)"
                  v-model="props.row.Store4"
                  :label="`${props.row.GStor4}`"
                  label-color="deep-orange"
                  type="number"
                  filled/>
            </td>
            <td class="text-center" style="width: 150px">
              <q-input
                  v-if="stores.filter(item=> item === 6).length > 0"
                  @input="event => inputControl6(event, props.row.GStor6, props.row)"
                  @change="controlState(props.row)"
                  min="0"
                  :disable=" (!$store.state.roles.some(v=>['admin'].includes(v))
                  && props.row.G_Code!==50101 || props.row.GStor6<0 || props.row.GStor6===0
                  || props.row.SaleG_Count===0 || isShopOrder)"
                  v-model="props.row.Store6"
                  :label="`${props.row.GStor6}`"
                  label-color="deep-orange"
                  type="number"
                  filled/>
            </td>
          </tr>
          <tr :props="props" :class="props.row.SaleG_Count===0?'bg-blue-grey-2':''" v-if="$q.screen.lt.md">
            <td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <q-chip square :label="props.row.Goods_Code" clickable @click="showProductDetails(props.row)"
                          color="red"
                          text-color="white"/>
                  <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="md" color="red"
                         v-if="props.row.G_Code!==50101">
                    <q-tooltip>
                      {{ props.row.General_Name }}
                    </q-tooltip>
                  </q-btn>
                  <q-space/>
                  <span class="text-subtitle2">{{ props.row.Goods_Name }}</span>
                </q-card-section>
                <q-card-section class="text-center no-padding">
                  <q-chip label="مانده سفارش" square>
                    <q-badge color="green" text-color="white" :label="props.row.SaleG_Count"/>
                  </q-chip>
                  <q-chip label="حواله شده" square>
                    <q-badge color="green" text-color="white" :label="props.row.HavaG_Count"/>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-expansion-item
                      label="صدور کالا از انبارها">
                    <div class="q-gutter-xs">
                      <q-input
                          v-if="stores.filter(item=> item === 1).length > 0"
                          @input="event => inputControl1(event, props.row.GStor1, props.row)"
                          @change="controlState(props.row)"
                          :disable="(props.row.G_Code!==50101
                          || (props.row.GStor1<0 || props.row.GStor1===0 || props.row.SaleG_Count===0)) || isShopOrder"
                          min="0"
                          v-model="props.row.Store1"
                          :label="`موجودی انبار مرکزی(${props.row.GStor1})`"
                          label-color="deep-orange"
                          type="number"
                          error-message="مقدار نامعتیر می باشد"
                          filled/>
                      <q-input
                          v-if="stores.filter(item=> item === 2).length > 0"
                          @input="event => inputControl2(event, props.row.GStor2, props.row)"
                          @change="controlState(props.row)"
                          :disable="(props.row.G_Code!==50101 || props.row.GStor2<0 ||props.row.GStor2===0
                          || props.row.SaleG_Count===0 || (![1139,113218, 115187, 6616].includes(orderInfo.Cs_ID))
                          && !$store.state.roles.some(v=>['admin','can_issue_product_from_shop'].includes(v)))"
                          min="0"
                          v-model="props.row.Store2"
                          :label="`موجودی انبار فروشگاه(${props.row.GStor2})`"
                          label-color="deep-orange"
                          type="number"
                          filled/>
                      <q-input
                          v-if="stores.filter(item=> item === 3).length > 0"
                          @input="event => inputControl3(event, props.row.GStor3, props.row)"
                          @change="controlState(props.row)"
                          :disable="(props.row.G_Code!==50101 || props.row.GStor3<0
                          || props.row.GStor3===0 || props.row.SaleG_Count===0 || isShopOrder)"
                          min="0"
                          v-model="props.row.Store3"
                          :label="`موجودی انبار پل پنجم(${props.row.GStor3})`"
                          label-color="deep-orange"
                          stack-label
                          type="number"
                          filled>
                      </q-input>
                      <q-input
                          v-if="stores.filter(item=> item === 4).length > 0"
                          @input="event => inputControl4(event, props.row.GStor4, props.row)"
                          @change="controlState(props.row)"
                          min="0"
                          :disable="(props.row.G_Code!==50101 || props.row.GStor4<0 || props.row.GStor4===0
                          || props.row.SaleG_Count===0 || isShopOrder)"
                          v-model="props.row.Store4"
                          :label="`موجودی کارخانه صاف(${props.row.GStor4})`"
                          label-color="deep-orange"
                          type="number"
                          filled/>
                      <q-input
                          v-if="stores.filter(item=> item === 6).length > 0"
                          @input="event => inputControl6(event, props.row.GStor6, props.row)"
                          @change="controlState(props.row)"
                          min="0"
                          :disable=" (!$store.state.roles.some(v=>['admin'].includes(v))
                          && props.row.G_Code!==50101 || props.row.GStor6<0
                          || props.row.GStor6===0  || props.row.SaleG_Count===0 || isShopOrder)"
                          v-model="props.row.Store6"
                          :label="`موجودی دیجیکالا(${props.row.GStor6})`"
                          label-color="deep-orange"
                          type="number"
                          filled/>
                    </div>
                  </q-expansion-item>

                </q-card-section>
              </q-card>
            </td>
          </tr>
        </template>
      </q-table>
    </q-card-section>
    <q-card-actions align="center">
      <q-btn :label="!orderNum? 'ویرایش حواله':'ثبت حواله'"
             type="button"
             v-if="orderItems.length>0"
             @click="issueSaleExi"
             :disable="orderItems.length===0 || inProgress"
             class="bg-indigo-6 text-white" icon="add_shopping_cart"/>
      <q-btn label="انصراف" v-close-popup flat class="q-ml-sm" icon="cancel" color="red"/>
    </q-card-actions>
    <q-dialog v-model="customerProfileDialog">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
    <q-dialog v-model="productDetailsDialog">
      <ProductDetail :product="selectedProduct"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="driverDialog">
      <Driver :sale_num="selectedSaleNum"
              @close-driver-dialog="closeDriverDialog"
              :order-num="orderNum"
              :is-shop-order="isShopOrder"
      />
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import Driver from "@/components/Driver/Driver.vue";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "IssueOrderRemittance",
  components: {ProductDetail, Driver,  CustomerInfo},
  props: {
    orderNum: {
      type: Number,
      required: true
    },
    saleNum: {
      type: Number,
      required: false
    },
    isShopOrder: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      driverDialog:false,
      selectedSaleNum:undefined,
      selectedProduct: undefined,
      issueVisible: false,
      pagination: {
        rowsPerPage: 50
      },
      inProgress: false,
      selectedCustomer: null,
      customerProfileDialog: false,
      productDetailsDialog: false,
      orderInfo: '',
      orderItems: [],
      stores: this.$store.state.issueOrderRemittanceStoreList && this.$store.state.issueOrderRemittanceStoreList.length === 1 ? [parseInt(this.$store.state.issueOrderRemittanceStoreList)] : this.$store.state.issueOrderRemittanceStoreList.toString().split(',').map(item => parseInt(item))
    }
  },
  methods: {
    ...mapActions({
      getOrderItems: 'Orders/prepareOrderForRemittance',
      getCustomerInfo: 'Customers/get_customer_info',
      IssueSale: 'Orders/IssueSale',
      getProductInfo: 'Products/getProductInfo'
    }),
    closeDriverDialog(){
      this.driverDialog = false
      this.$emit('refresh-data')
    },
    showProductDetails(productInfo) {
      this.getProductInfo(productInfo.Goods_ID).then((res) => {
        this.selectedProduct = res[0]
        this.productDetailsDialog = true
      })
    },
    issueSaleExi() {
      this.inProgress = true;
      this.IssueSale({
        CsId: this.orderInfo.Cs_ID,
        orderNum: this.orderNum,
        items: this.orderItems.filter(item => item.Store1 + item.Store2 + item.Store3 + item.Store4 + item.Store5 + item.Store6 > 0)
      }).then((res) => {
        this.$q.notify({
          type: 'positive',
          color: 'positive',
          position: 'top',
          message: `حواله به شماره ${eval(res.hava)[0].Sale_Num} صادر شد`
        })
        this.selectedSaleNum = eval(res.hava)[0].Sale_Num
        if (!this.isShopOrder){
          this.$emit('refresh-data')
        }else{
          this.driverDialog = true
        }
        this.inProgress = false;
      }).catch(() => {
        this.inProgress = false;
      })
    },
    inputControl1(event, baseValue, row) {
      if (parseInt(event) > parseInt(baseValue)) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقدار وارد شده از موجودی انبار بیشتر است'
        })
        row.Store1 = 0
      }
    },
    inputControl2(event, baseValue, row) {
      if (parseInt(event) > parseInt(baseValue)) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقدار وارد شده از موجودی انبار بیشتر است'
        })
        row.Store2 = 0
      }
    },
    inputControl3(event, baseValue, row) {
      if (parseInt(event) > parseInt(baseValue)) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقدار وارد شده از موجودی انبار بیشتر است'
        })
        row.Store3 = 0
      }
    },
    inputControl4(event, baseValue, row) {
      if (parseInt(event) > parseInt(baseValue)) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقدار وارد شده از موجودی انبار بیشتر است'
        })
        row.Store4 = 0
      }
    },
    inputControl6(event, baseValue, row) {
      if (parseInt(event) > parseInt(baseValue)) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقدار وارد شده از موجودی انبار بیشتر است'
        })
        row.Store4 = 0
      }
    },
    controlState(row) {
      let total = parseInt(row.Store1) + parseInt(row.Store2) + parseInt(row.Store3) + parseInt(row.Store4) + parseInt(row.Store6)
      if (total > parseInt(row.SaleG_Count)) {
        row.Store1 = 0
        row.Store2 = 0
        row.Store3 = 0
        row.Store4 = 0
        row.Store6 = 0
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'مقادیر وارد شده بیشتر از سفارش می باشد'
        })
      }
    },
    showCustomerInfo() {
      this.getCustomerInfo(this.orderInfo.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerProfileDialog = true
      })
    }
  },
  created() {
    if (this.orderNum) {
      this.getOrderItems(this.orderNum).then((res) => {
        this.orderInfo = eval(res.orderHeaderInfo)[0]
        this.orderItems = eval(res.orderDetailsInfo)
      })
    }
  }
}
</script>

<style scoped>

</style>